export default __webpack_public_path__ + "static/media/02.84dde421.jpg";